import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { useAuth } from '../contexts/AuthContext';
import './navbar-style.css';

const TopNav = ({ dark = false, transparent = false, addClass = '' }) => {
  const { user, logout } = useAuth();
  let navClass = `navbar navbar-expand-lg ${dark ? 'navbar-dark' : 'navbar-light'} ${transparent ? 'bg-transparent' : 'bg-light'}`;

  navClass += ` ${addClass}`;
  
  return (
    <nav className={navClass} id="top-nav-navbar">
      <div className="container">
      <Link className="navbar-brand font-weight-bold cond-text" to="/"><span className="brand-menu-text font-800" style={{fontSize:1.5+'em'}}>Menu</span><span className='brand-portal-text font-300'>Portal</span></Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ml-auto">
            {/* <li className="nav-item">
              <Link className="nav-link" to="/search">Search</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/docs">Docs</Link>
            </li>
            {!user && (
              <li className="nav-item">
                <Link className="nav-link" to="/login">Login</Link>
              </li>
            )}
            {user && (
              <>
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={logout}>Logout</Link>
                </li>
              </>
            )}
            {!user && (
              <li className="nav-item">
                <Link className="nav-link" to="/register">Get Started</Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default TopNav; 